import ExcludeFromLookup from '../../../../../../enums/ExcludeFromLookup';
import addressee from '../../defaultFieldDefinitions/Addressee';
import postCode from '../../defaultFieldDefinitions/PostCode';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';

export default [
  {
    ...addressee,
    maxLength: 30,
    placeholder: 'checkout.delivery.address.field.placeholder.name.text',
  },
  {
    ...postCode,
    placeholder: 'checkout.delivery.address.field.placeholder.postal.code.text',
    validate: [required.postCode, max.lengthPostCode(16)],
  },
  {
    name: 'streetName',
    label: 'checkout.delivery.address.field.label.town.text',
    placeholder: 'checkout.delivery.address.field.placeholder.town.text',
    required: true,
    maxLength: 30,
    validate: [required.address1, max.lengthAddress(30)],
  },
  {
    name: 'townCity',
    label: 'checkout.delivery.address.field.label.townCity.text',
    placeholder: 'checkout.delivery.address.field.placeholder.townCity.text',
    required: true,
    maxLength: 30,
    validate: [required.townCity, max.lengthAddress(30)],
  },
  {
    name: 'addressLine2',
    label: 'checkout.address.field.label.address2.text',
    placeholder: 'checkout.delivery.address.field.placeholder.address2.text',
    maxLength: 30,
    validate: [max.lengthField(30)],
    excludeFromAddressLookup: ExcludeFromLookup.AFTER,
  },
];
